import { Injectable } from '@angular/core';

import { DSL_NOT_READY, DslCacheService, DslRecordable, DslRecorderService, DslValuesProvider, UserService } from '@frontend/vanilla/core';

import { ComplianceStatus, LoyaltyLoginValidation, LoyaltyPropositions } from './loyalty-login.models';
import { LoyaltyLoginService } from './loyalty-login.service';

@Injectable()
export class LoyaltyLoginDslValuesProvider implements DslValuesProvider {
    constructor(
        private dslRecorderService: DslRecorderService,
        private loyaltyLoginService: LoyaltyLoginService,
        private userService: UserService,
        dslCacheService: DslCacheService,
    ) {
        this.loyaltyLoginService.loyaltyLoginValidation.subscribe(() => {
            dslCacheService.invalidate(['loyaltyLogin']);
        });
    }

    getProviders(): { [provider: string]: DslRecordable } {
        return {
            LoyaltyLogin: this.dslRecorderService
                .createRecordable('loyaltyLogin')
                .createProperty(this.getLoyaltyValidationProperty('LoyaltyAccountName', 'loyaltyAccountName'))
                .createProperty(this.getLoyaltyValidationProperty('LoyaltyCardNo', 'loyaltyCardNo'))
                .createProperty(this.getLoyaltyPropositionsProperty('AccaProposition', 'acca'))
                .createProperty(this.getLoyaltyPropositionsProperty('BogProposition', 'bog'))
                .createProperty(this.getLoyaltyPropositionsProperty('CrmCampaignsProposition', 'crmCampaigns'))
                .createProperty(this.getLoyaltyPropositionsProperty('OneTwoFreeProposition', 'oneTwoFree'))
                .createProperty(this.getComplianceStatusProperty('SuppressionStatus', 'suppressionStatus'))
                .createProperty(this.getComplianceStatusProperty('RgStatus', 'rgStatus'))
                .createProperty(this.getComplianceStatusProperty('AccountStatus', 'accountStatus'))
                .createProperty(this.getComplianceStatusProperty('KycStatus', 'kycStatus')),
        };
    }

    private getLoyaltyValidationProperty(name: string, key: keyof LoyaltyLoginValidation) {
        return {
            name,
            get: () => (this.userService.isAuthenticated ? (this.loyaltyLoginService.loyaltyValidation?.[key] ?? DSL_NOT_READY) : ''),
            deps: ['loyaltyLogin', 'user.isAuthenticated'],
        };
    }

    private getLoyaltyPropositionsProperty(name: string, key: keyof LoyaltyPropositions) {
        return {
            name,
            get: () =>
                this.userService.isAuthenticated ? (this.loyaltyLoginService.loyaltyValidation?.loyaltyPropositions?.[key] ?? DSL_NOT_READY) : '',
            deps: ['loyaltyLogin', 'user.isAuthenticated'],
        };
    }

    private getComplianceStatusProperty(name: string, key: keyof ComplianceStatus) {
        return {
            name,
            get: () =>
                this.userService.isAuthenticated ? (this.loyaltyLoginService.loyaltyValidation?.complianceStatus?.[key] ?? DSL_NOT_READY) : '',
            deps: ['loyaltyLogin', 'user.isAuthenticated'],
        };
    }
}
